const CYCLE_COUNT_FRAGMENT = `
fragment cycleCount on CycleCount {
  id
  status
  locationAmount
  countedAmount
  variance
  totalVariancePrice
  countedAt
  completedBy {
    id
    name
  }
  createdAt
  updatedAt
  location {
    id
    code
    description
    locationType
  }
  countedBy {
    id
    name
  }
}
`

export const CYCLE_COUNTS_QUERY = `
query CycleCounts($accountId: Int!, $branchId: Int, $locationId: Int) {
  cycleCounts(accountId: $accountId, branchId: $branchId, locationId: $locationId) {
    ...cycleCount
  }
}
${CYCLE_COUNT_FRAGMENT}
`

export const CYCLE_COUNT_QUERY = `
query CycleCount($id: Int!) {
  cycleCount(id: $id) {
    ...cycleCount
    cycleCountItems {
      id
      status
      locationAmount
      countedAmount
      variance
      totalVariancePrice
      createdAt
      updatedAt
      locationItem {
        id
        inventory
        unit
        price
        product {
          id
          name
          code
        }
      }
    }
  }
}
${CYCLE_COUNT_FRAGMENT}
`

export const UPDATE_CYCLE_COUNT_MUTATION = `
mutation CycleCountUpdate($id: Int!, $attributes: CycleCountUpdateAttributes!) {
  cycleCountUpdate(id: $id, attributes: $attributes) {
    result {
      ...cycleCount
    }
    errors
  }
}
${CYCLE_COUNT_FRAGMENT}
`

export const UPDATE_CYCLE_COUNT_ITEMS_MUTATION = `
mutation UpdateCycleCountItems($cycleCountId: Int!, $ids: [Int!]!, $status: CycleCountItemStatusesEnum!) {
  cycleCountItemsUpdate(cycleCountId: $cycleCountId, ids: $ids, status: $status) {
    result {
      id
      status
      locationAmount
      countedAmount
      variance
      totalVariancePrice
    }
    errors
  }
}
`
